import type { RequestOptions } from "../common/server";
import type { IdOrFilesystemId } from "./types";
import type { BookmarkJs, InsertLocation, ShortcutCreateJs } from "@/generated/models";
import { joinURL } from "ufo";
import { objectToFormData } from "@/services/utils/formData";
import { cloudApiUrl } from "../urls";
import { server } from "./server";

export type CreateModel = IdOrFilesystemId & { Url?: string; Name?: string; insertLocation?: InsertLocation; insertAfter?: string };

export async function create(model: CreateModel) {
  const formData = objectToFormData(model);
  const response = await server.post("bookmarks/create", { body: formData });
  return await response.json() as ShortcutCreateJs;
}

export async function getBookmark(shortcut: string, { signal }: RequestOptions = {}) {
  const response = await server.get(`bookmarks/${shortcut.toLowerCase()}`, {
    signal,
  });
  return await response.json() as BookmarkJs;
}

export interface UpdateBookmarkModel {
  Url: string;
  Name?: string;
}
export async function updateBookmark(shortcut: string, model: UpdateBookmarkModel) {
  const formData = objectToFormData(model);
  const response = await server.post(`bookmarks/${shortcut.toLowerCase()}`, { body: formData });
  return await response.json() as BookmarkJs;
}

export function getNavigateLink(shortcut: string) {
  const result = joinURL(cloudApiUrl, `bookmarks/${shortcut.toLowerCase()}/navigate`);
  return result;
}
